var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createElement } from "react";
import { ChevronRight, Home } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { OnClickable } from "../BackToButton/RestrictionClearingBackButton";
import styles from "./Breadcrumb.module.scss";
import routes from "../../routes/routes.json";
import { useGetSingleAvailableCohortReportsQuery } from "../../store/api/core";
import { useLeaderTitle } from "../../pages/CohortCapabilitiesLeadersV2/CohortCapabilitiesLeadersV2";
import { getRoute } from "../../routes/getAllRoutes";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var ClickableBreadcrumb = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    return (_jsx("span", __assign({ className: "".concat(styles.breadcrumbText, " ").concat(styles.breadcrumbItem) }, getAutomationTag(TestTag.BreadcrumbItem), { onClick: function () { return onClick && onClick(); } }, { children: children })));
};
/* eslint-disable @typescript-eslint/no-unused-vars */
var CohortInsightsV2 = function () {
    return (_jsx("span", __assign({ className: styles.breadcrumbHome }, { children: _jsx(Home, { className: styles.home }) })));
};
var CohortInsightsRestricted = function (_a) {
    var _b;
    var reportId = _a.reportId;
    var response = useGetSingleAvailableCohortReportsQuery({ reportId: reportId || "" }, { shouldSkipCall: function () { return !reportId; } });
    return ((_b = response.data) === null || _b === void 0 ? void 0 : _b.reportName) || "";
};
var CohortCategorizedSkillRestricted = function (_a) {
    var skillGroup = _a.skillGroup;
    return skillGroup || "";
};
var CohortInsightsSkillRestricted = function (_a) {
    var skillName = _a.skillName;
    return skillName;
};
var CohortLeadersRestricted = function (params) {
    var title = useLeaderTitle(params);
    return title || "";
};
/* eslint-enable @typescript-eslint/no-unused-vars */
var chains = [
    "CohortInsightsRestricted",
    "CohortLeadersRestricted",
    "CohortCategorizedSkillRestricted",
    "CohortLeadershipCapabilities",
    "CohortInsightsSkillRestricted",
]
    .map(function (key) { return routes[key]; })
    .map(function (route) { return ({
    breadcrumbs: route.breadcrumbs.map(function (key) { return ({
        element: eval(key),
        name: key,
    }); }),
    url: route.url,
    route: route,
}); });
var Seperator = _jsx(ChevronRight, { className: styles.home });
var doesRouteMatch = function (routeUrl, pathname) {
    var routeSegments = routeUrl.split("/").filter(Boolean);
    var pathSegments = pathname.split("/").filter(Boolean);
    if (routeSegments.length !== pathSegments.length) {
        return false;
    }
    for (var i = 0; i < routeSegments.length; i++) {
        if (routeSegments[i] !== pathSegments[i] &&
            !routeSegments[i].startsWith(":")) {
            return false;
        }
    }
    return true;
};
var allowedParamKeys = new Set([
    "reportId",
    "role",
    "project",
    "category",
    "skillGroup",
    "skillName",
]);
export var Breadcrumb = function () {
    var _a;
    var navigate = useNavigate();
    var params = useParams();
    var location = useLocation();
    var pathname = location.pathname;
    var chain = ((_a = chains.find(function (_a) {
        var url = _a.url;
        return doesRouteMatch(url, pathname);
    })) === null || _a === void 0 ? void 0 : _a.breadcrumbs) || [];
    if ((chain === null || chain === void 0 ? void 0 : chain.length) < 1) {
        return _jsx(_Fragment, {});
    }
    var clearRestrictions = doesRouteMatch(getRoute("CohortLeadersRestricted"), pathname);
    var parts = chain.reduce(function (current, breadcrumb, index) {
        var url = Object.keys(params)
            .filter(function (key) { return allowedParamKeys.has(key); })
            .reduce(function (current, key) {
            return current.replace(":".concat(encodeURIComponent(key)), encodeURIComponent(params[key] || ""));
        }, getRoute(breadcrumb.name));
        var doNavigate = function () {
            if (!url.startsWith("/")) {
                return;
            }
            navigate(url);
        };
        return __spreadArray(__spreadArray(__spreadArray([], current, true), (index !== 0 ? [Seperator] : []), true), [
            clearRestrictions ? (_jsx(OnClickable, { element: ClickableBreadcrumb, additional: { children: createElement(breadcrumb.element, params) }, onClick: doNavigate })) : (_jsx(ClickableBreadcrumb, __assign({ onClick: doNavigate }, { children: createElement(breadcrumb.element, params) }))),
        ], false);
    }, []);
    return _jsx("div", __assign({ className: styles.Breadcrumb }, { children: parts }));
};
